import { useLegalDocuments } from '../../hooks/useLegalDocuments'
import { LegalDocumentContent } from '../LegalDocumentContent'
import { LegalPageShell } from '../LegalPageShell'

export function TermsOfUsePage() {
  const { data: documents } = useLegalDocuments()
  const terms = documents?.find(document => document.kind === 'terms')

  return (
    <LegalPageShell>
      <LegalDocumentContent title="Termos de Uso" document={terms} />
    </LegalPageShell>
  )
}
